/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './index.styl';

const Controls = ({ children, className = 'pa2', style }) => (
  <div {...{ children, className, style }} styleName="controls" />
);

Controls.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default CSSModules(Controls, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/ContentArea/Controls.jsx